@for (rota of rotas; track rota.path) 
{
    @if (rota.data) {
        <erp-sidebar-item [tooltip]="rota.data['label']" [itemClass]="rota.data['icon']"
            [routerLinkActiveClass]="'router-link-active'" [routerLink]="rota.path"></erp-sidebar-item>
    }
}
<erp-sidebar-item [tooltip]="'Sair'" [itemClass]="'pi pi-sign-out'" class="logout-button" [action]="logout" ></erp-sidebar-item>
